import {
  FacebookGlyph,
  LinkedInGlyph,
  MediumGlyph,
  TwitterGlyph,
} from 'Assets/Svg/Icons'

import { SOCIAL_LINKS } from 'Constants/ExternalLinks'

enum SocialIds {
  Facebook = 'facebook',
  Twitter = 'twitter',
  Medium = 'medium=',
  LinkedIn = 'linkedIn',
}

export const SOCIALS = [
  {
    id: SocialIds.Facebook,
    icon: FacebookGlyph(),
    label: 'StartupCraft on Facebook',
    link: SOCIAL_LINKS.FACEBOOK,
  },
  {
    id: SocialIds.Twitter,
    icon: TwitterGlyph(),
    label: 'StartupCraft on X',
    link: SOCIAL_LINKS.TWITTER,
  },
  {
    id: SocialIds.Medium,
    icon: MediumGlyph(),
    label: 'StartupCraft on Medium',
    link: SOCIAL_LINKS.MEDIUM,
  },
  {
    id: SocialIds.LinkedIn,
    icon: LinkedInGlyph(),
    label: 'StartupCraft on LinkedIn',
    link: SOCIAL_LINKS.LINKED_IN,
  },
]
